import validate from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/middleware/auth.global.ts";
import manifest_45route_45rule from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "dev-only": () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/middleware/dev-only.ts"),
  worker: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/middleware/worker.ts")
}